import { CssBaseline } from '@mui/material';
import type { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';

import {
  LiveRegionProvider,
  MobileZoomContextProvider,
  ToastProvider,
  TranslationsProvider,
} from '@state/checkout-contexts';
import { ChkPageWrapper } from '@ui/checkout-components';

import App from './app';
import { ThemeProvider } from './components/ThemeProvider/ThemeProvider';
import './translations/setup';
import { ErrorContextProvider } from './contexts/error/errorContext';
import { JwtContextProvider } from './hooks/useJwtContext/useJwtContext';
import { InstitutionDetailsContextProvider } from './providers/InstitutionDetailsContextProvider/InstitutionDetailsContextProvider';
import { ScaSubjectProvider } from './providers/ScaSubjectProvider/ScaSubjectProvider';
import { SUPPORTED_LANGUAGES } from './translations/setup';

export type DecoratorProps = { unbranded?: boolean; queryClient: QueryClient };

export function Decorators({ unbranded, queryClient }: DecoratorProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <MobileZoomContextProvider>
        <JwtContextProvider>
          <LiveRegionProvider>
            <ThemeProvider variant={unbranded ? 'unbranded' : 'volt'}>
              <CssBaseline />
              <ToastProvider>
                <TranslationsProvider supportedLanguages={SUPPORTED_LANGUAGES}>
                  <ErrorContextProvider>
                    <InstitutionDetailsContextProvider>
                      <ScaSubjectProvider>
                        <ChkPageWrapper>
                          <App />
                        </ChkPageWrapper>
                      </ScaSubjectProvider>
                    </InstitutionDetailsContextProvider>
                  </ErrorContextProvider>
                </TranslationsProvider>
              </ToastProvider>
            </ThemeProvider>
          </LiveRegionProvider>
        </JwtContextProvider>
      </MobileZoomContextProvider>
    </QueryClientProvider>
  );
}
